<ng-container *transloco="let t; read: 'contact'">
  <div class="contact p-grid p-nogutter p-jc-center">
    <div class="p-grid p-nogutter contact__wrapper p-jc-center">
      <div class="p-col-12 p-md-6 p-xl-5 contact__left-column">
        <div class="p-grid">
          <div class="p-col-12 p-lg-6 contact__logo p-text-center">
            <img
              src="assets/icons/logo-white.svg"
              alt="gap logo"
              loading="lazy"
              decoding="async" width="145" height="73">
          </div>

          <div class="p-col-12 p-lg-6 contact__section">
            <h2 class="home-heading">{{ t('header.1') }}</h2>
            <p>{{ t('informations.ais.description') }}</p>
            <p class="p-text-bold">{{ t('informations.ais.fullName') }}</p>
            <p>{{ t('informations.ais.address') }}</p>
            <p class="p-text-bold">
              {{ t('informations.ais.emailDesc') }}
              <a
                href="mailto:bok@gaponline.pl"
                class="textYellow"
                >{{ t('informations.ais.email') }}</a
              >
            </p>
            <p class="p-text-bold">
              {{ t('informations.ais.phoneNoDesc')
              }}<span class="textYellow">{{
                t('informations.ais.phoneNo')
              }}</span>
            </p>
            <p class="p-text-bold mb-16">
              {{ t('informations.ais.proxyDesc') }}
              <a
                target="_blank"
                href="assets/downloads/pelnomocnictwo.pdf"
                class="textYellow"
                >{{ t('informations.ais.proxy') }}</a
              >
            </p>
          </div>

          <div class="p-col-12 contact__section contact__separator p-pt-0">
            <div class="contact__separator-line"></div>
            <p class="p-text-bold">
              {{ t('informations.defend.description') }}
            </p>
          </div>

          <div class="p-col-12 p-md-6 contact__section p-pt-0">
            <h2 class="home-heading addTopBorder">{{ t('header.2') }}</h2>
            <p>{{ t('informations.fortegra.description') }}</p>
            <p class="p-text-bold p-text-uppercase">
              {{ t('informations.fortegra.fullName') }}
            </p>
            <p>{{ t('informations.fortegra.address') }}</p>
            <a
              target="_blank"
              href="http://www.fortegra.com"
              class="textYellow p-text-bold"
              >{{ t('informations.fortegra.homepage') }}</a
            >
            <div class="p-mt-3">
              <img
                src="assets/icons/fortegra-logo.svg"
                class="defendLogo"
                alt="fortegra logo"
                loading="lazy"
                decoding="async" width="109" height="78">
            </div>
          </div>

          <div class="p-col-12 p-md-6 contact__section p-pt-0">
            <h2 class="home-heading addTopBorder">{{ t('header.5') }}</h2>
            <p class="p-text-bold">{{ t('informations.defend.fullName') }}</p>
            <p>{{ t('informations.defend.address') }}</p>
            <p class="p-text-bold">
              {{ t('informations.defend.emailDesc') }}
              <a
                href="mailto:info@defendinsurance.pl"
                class="textYellow"
                >{{ t('informations.defend.email') }}</a
              >
            </p>
            <p class="p-text-bold">
              {{ t('informations.defend.phoneNoDesc')
              }}<span class="textYellow">{{
                t('informations.defend.phoneNo')
              }}</span>
            </p>
            <p>
              <a
                target="_blank"
                href="http://www.defendinsurance.pl"
                class="textYellow p-text-bold"
                >{{ t('informations.defend.homepage') }}</a
              >
            </p>
            <div class="defend_logo">
              <img
                src="assets/icons/defend-logo.svg"
                class="defendLogo"
                alt="defend logo"
                loading="lazy"
                decoding="async" width="169" height="85">
            </div>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-xl-5 contact__right-column contact__form">
        <div class="contact__form__wrapper">
          <div class="contact__form__header">
            <h2
              class="home-heading p-text-uppercase"
              [innerHTML]="t('header.4')"></h2>
            <p [innerHTML]="t('form.description')"></p>
            <p
              *ngIf="!formEnabled"
              class="p-mt-2 p-text-secondary">
              {{ t('form.unavailable') }}
            </p>
          </div>
          <form
            [formGroup]="contactFormGroup"
            (focusin)="warmRecaptcha()"
            (ngSubmit)="onSubmit()">
            <div
              class="form-group"
              [class.form-group--unavailable]="!formEnabled">
              <div class="p-d-md-flex">
                <input
                  class="contactInput"
                  id="name"
                  type="text"
                  pInputText
                  placeholder="{{ t('form.name') }}"
                  formControlName="name" />
              </div>
              <div class="p-d-md-flex">
                <input
                  class="contactInput"
                  id="phoneNo"
                  type="tel"
                  pInputText
                  placeholder="{{ t('form.phoneNo') }}"
                  formControlName="phoneNo" />
                <input
                  class="contactInput"
                  id="email"
                  type="email"
                  pInputText
                  placeholder="{{ t('form.email') }}"
                  formControlName="email" />
              </div>

              <div class="p-d-md-flex">
                <input
                  class="contactInput"
                  id="brand"
                  type="text"
                  pInputText
                  placeholder="{{ t('form.brand') }}"
                  formControlName="brand" />
                <input
                  class="contactInput"
                  id="model"
                  type="text"
                  pInputText
                  placeholder="{{ t('form.model') }}"
                  formControlName="model" />
              </div>

              <div class="p-d-md-flex">
                <input
                  class="contactInput"
                  id="yearOfProduction"
                  type="text"
                  pInputText
                  placeholder="{{ t('form.yearOfProduction') }}"
                  formControlName="yearOfProduction" />
                <input
                  class="contactInput"
                  id="value"
                  type="text"
                  pInputText
                  placeholder="{{ t('form.value') }}"
                  formControlName="value" />
              </div>

              <div class="p-d-md-flex">
                <p-inputNumber
                  class="contactInput"
                  inputStyleClass="contactInputNumber"
                  inputId="mileage"
                  [placeholder]="t('form.mileage')"
                  formControlName="mileage"
                  [min]="0"
                  [useGrouping]="false"></p-inputNumber>
                <p-inputNumber
                  class="contactInput"
                  inputStyleClass="contactInputNumber"
                  inputId="gapPeriod"
                  [placeholder]="t('form.gapPeriod')"
                  formControlName="gapPeriod"
                  [min]="12"
                  [max]="60"
                  [useGrouping]="false"></p-inputNumber>
              </div>
              <div>
                <textarea
                  class="contactInput p-mb-1"
                  id="textMsg"
                  [rows]="3"
                  [cols]="30"
                  autoResize="autoResize"
                  pInputTextarea
                  placeholder="{{ t('form.textMsg') }}"
                  formControlName="textMsg"></textarea>
              </div>

              <div class="p-field-checkbox">
                <p-checkbox
                  [binary]="true"
                  formControlName="agreement1"
                  inputId="contactCheckbox1"></p-checkbox>
                <label for="contactCheckbox1"
                  >{{ t('form.checkbox1Desc1')
                  }}<a
                    target="_blank"
                    href="assets/downloads/polityka-prywatnosci.pdf"
                    >{{ t('form.checkbox1Desc2') }}</a
                  ></label
                >
              </div>

              <div class="p-field-checkbox">
                <p-checkbox
                  [binary]="true"
                  formControlName="agreement2"
                  inputId="contactCheckbox2"></p-checkbox>
                <label for="contactCheckbox2"
                  >{{ t('form.checkbox2Desc1') }}
                  <a
                    target="_blank"
                    href="assets/downloads/polityka-prywatnosci.pdf"
                    >{{ t('form.checkbox2Desc2') }}</a
                  >
                  {{ t('form.checkbox2Desc3') }}
                </label>
              </div>
              <p
                *ngIf="submitThanks"
                class="form-thanks"
                role="status">
                {{ t('confirmation.sent') }}
              </p>
              <div class="p-d-flex p-jc-center p-jc-md-end p-mt-4">
                <button
                  type="submit"
                  class="buttonYellow"
                  [class.buttonYellow--inactive]="submitInactive"
                  [disabled]="recaptchaPending || thankYouCooldown"
                  style="width: 251px">
                  {{ t('form.button') }} >
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-container>
